import { Collapsible, CollapsibleContent, CollapsibleListTrigger } from "@qw/ui";
import { useMemo } from "react";

import { getResourceLinkHandler } from "../chat.helpers";
import { useGeneratedArtifacts } from "../hooks/use-generated-artifacts";
import { useChat } from "../providers/chat-provider";
import { getArtifactRow } from "./artifact-rows/get-artifact-row";

export const ChatArtifactDrawer = () => {
  const { chatSession, resourceLinkHandlers } = useChat();
  const generated = useGeneratedArtifacts();
  const artifacts = useMemo(
    () => generated.filter((resource) => getResourceLinkHandler(resource, resourceLinkHandlers)),
    [generated, resourceLinkHandlers]
  );

  if (artifacts.length === 0) {
    return null;
  }

  return (
    <Collapsible key={chatSession.id} defaultOpen={false} className="border-b">
      <CollapsibleListTrigger count={artifacts.length} className="h-8 gap-2 px-3">
        Artifacts
      </CollapsibleListTrigger>
      <CollapsibleContent>
        <div className="max-h-[min(45dvh,24rem)] overflow-y-auto overscroll-contain">
          {artifacts.map((resource) => {
            const Row = getArtifactRow(resource);
            return <Row key={resource.uri} resource={resource} />;
          })}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};
